<template>
  <div @click="onClick" :class="['select-box', { 'is-active': isActive }]">
    <div class="select-box-header">
      <div class="select-box-header-period">{{ text.period }}</div>
      <div class="select-box-header-amount">{{ text.amount }}</div>
    </div>
    <div class="select-box-details">
      <div class="select-box-details-details">{{ text.details }}</div>
      <div class="select-box-details-amount-details">
        {{ text.amount_details }}
      </div>
    </div>
    <div class="select-box-headset" v-if="text.has_headset">
      <div class="select-box-headset-details">
        <div class="select-box-headset-details-name">oVRcome VR headset</div>
        <div class="select-box-headset-details-price">
          <AlertTag v-if="text.headset_price == 0" text="Free!" />
          <span v-else>US${{ text.headset_price }}</span>
        </div>
      </div>
      <div class="select-box-headset-details-extra">For smartphones</div>
    </div>
    <div class="select-box-pay-today">{{ text.pay_today }}</div>
  </div>
</template>
<script>
import AlertTag from "./AlertTag.vue";

export default {
  name: "select-box",
  props: {
    text: Object,
    onClick: Function,
    isActive: Boolean,
  },
  methods: {},
  components: { AlertTag },
};
</script>
